import Character from "@lss/common/src/shell/Character";
import { TimageINT } from "../../src/store/slices/gameObjectSlice";
import { images } from "../story/images";

interface VanessaPropertiesINT {

}

const vanessaProperties: VanessaPropertiesINT = {
};

const vanessa = new Character<VanessaPropertiesINT>("Vanessa", vanessaProperties, "#FF63C7FF");

export {
    vanessa,
};